import React, { Component } from 'react';
// import moment from 'moment';
import { connect } from 'react-redux';
import { AlertsActions } from '../../store';
import { Spinner } from '../Spinner';
import { ConnectedInformationGraph } from './components/InformationGraph';
import { ConnectedInformationComments } from './components/InformationComments';

import './EventInformation.css';
import { Notification } from '../Notification';

export class EventInformation extends Component {
  componentDidMount() {
    document.title = 'Parity | Incident Details';

    this.getIncident();
  }

  getIncident = () => {
    const { getIncidentDetails } = this.props;
    const { building, incident } = this.props.match.params;

    getIncidentDetails(building, incident);
  };

  renderGraph = () => {
    const { selectedIncident } = this.props;

    if (selectedIncident.context_data_api_location) {
      return <ConnectedInformationGraph dataApiLocation={selectedIncident.context_data_api_location} />;
    }
  };

  renderMostRecentEvents = () => {
    return (
      <div className="event-information__legend-item">
        <Notification type="info" message="No recent events to show." />
      </div>
    );
  };

  renderComments = () => {
    const {
      selectedIncident: { comments, comments_api_location: commentsApiLocation },
    } = this.props;

    if (commentsApiLocation) {
      return (
        <ConnectedInformationComments
          comments={comments}
          commentApiLocation={commentsApiLocation}
          triggerRefetch={this.getIncident}
        />
      );
    }
  };

  render() {
    const {
      selectedIncident: { name },
      isLoading,
      selectedBuilding,
    } = this.props;
    // const formattedDate = moment(lastTimestamp).format('LLL');

    const headerTitleDesktop = `Incident details - ${selectedBuilding.name} ${name}`;
    const headerTitleMobile = `${selectedBuilding.name} ${name}`;
    const desktopOnlyColumnClass = 'equal-width desktop-only';

    if (isLoading) {
      return (
        <div className="event-information--loading">
          <Spinner />
        </div>
      );
    }

    return (
      <div className="event-information">
        <div className="event-information__header">
          <div className="event-information__header-title">
            {window.innerWidth < 599 ? headerTitleMobile : headerTitleDesktop}
          </div>
        </div>
        <div className="event-information__main">
          {this.renderGraph()}
          <div className="event-information__events-section">
            <div className="event-information__legend">
              <div className="event-information__legend-header">
                <div className="event-information__legend-title">Most recent events</div>
              </div>
              <div className="event-information__column-names">
                <div className="equal-width">Data tag</div>
                <div className="equal-width">Operator</div>
                <div className="equal-width">Value</div>
                <div className={desktopOnlyColumnClass}>Rolling avg minutes</div>
                <div className={desktopOnlyColumnClass}>Message</div>
              </div>
              {this.renderMostRecentEvents()}
            </div>
          </div>
          <div className="event-information__comments-section">
            <div className="event-information__legend">
              <div className="event-information__legend-header">
                <div className="event-information__legend-title">Comments</div>
              </div>
              {this.renderComments()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isLoading: state.alertsReducer.isLoadingIncident,
    selectedIncident: state.alertsReducer.selectedIncident,
    selectedBuilding: state.buildingReducer.selectedBuilding,
  };
}

const mapDispatchToProps = {
  getIncidentDetails: AlertsActions.getIncidentDetails,
};

export const ConnectedEventInformation = connect(mapStateToProps, mapDispatchToProps)(EventInformation);
